
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glass?: boolean;
}

export default function Card({ children, className = '', hover = true, glass = false }: CardProps) {
  const baseClasses = 'rounded-2xl transition-all duration-300';
  const glassClasses = glass 
    ? 'bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl' 
    : 'bg-white/95 backdrop-blur-sm border border-white/30 shadow-xl';
  const hoverClasses = hover 
    ? 'hover:shadow-2xl hover:-translate-y-1 hover:bg-white/15 cursor-pointer' 
    : '';

  return (
    <div className={`${baseClasses} ${glassClasses} ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
}
